import React, { ReactElement } from 'react';

import { Badge } from 'components/elements/badge/badge';
import { BadgeType } from 'components/elements/badge/types';
import IconChecked from 'components/icons/checked';
import IconCross from 'components/icons/cross';
import IconDash from 'components/icons/dash';
import IconRefresh from 'components/icons/refresh';
import IconRefund from 'components/icons/refund';

import { PwcOrderStatus } from 'types/pwcOrder';

import { badgePropsMap } from './keys';
import { BadgeContent } from './styles';

interface StatusBadgeProps {
  status: PwcOrderStatus;
}

const badgeToIconMap: Record<PwcOrderStatus, ReactElement | null> = {
  [PwcOrderStatus.Initiated]: <IconRefresh />,
  [PwcOrderStatus.Pending]: <IconRefresh />,
  [PwcOrderStatus.Submitted]: <IconRefresh />,
  [PwcOrderStatus.Confirmed]: <IconChecked />,
  [PwcOrderStatus.Completed]: <IconChecked />,
  [PwcOrderStatus.Incomplete]: <IconCross />,
  [PwcOrderStatus.Overpaid]: <IconChecked />,
  [PwcOrderStatus.Expired]: <IconCross />,
  [PwcOrderStatus.Canceled]: <IconCross />,
  [PwcOrderStatus.Declined]: <IconCross />,
  [PwcOrderStatus.Failed]: <IconCross />,
  [PwcOrderStatus.RefundInitiated]: <IconRefund />,
  [PwcOrderStatus.RefundSubmitted]: <IconRefund />,
  [PwcOrderStatus.RefundFailed]: <IconRefund />,
  [PwcOrderStatus.Refunded]: <IconRefund />,
  [PwcOrderStatus.PartialRefund]: <IconRefund />,
};

const badgeTypeMap: Record<PwcOrderStatus, BadgeType> = {
  [PwcOrderStatus.Initiated]: BadgeType.Default,
  [PwcOrderStatus.Pending]: BadgeType.Default,
  [PwcOrderStatus.Submitted]: BadgeType.Default,
  [PwcOrderStatus.Confirmed]: BadgeType.Success,
  [PwcOrderStatus.Completed]: BadgeType.Success,
  [PwcOrderStatus.Incomplete]: BadgeType.Fail,
  [PwcOrderStatus.Overpaid]: BadgeType.Success,
  [PwcOrderStatus.Expired]: BadgeType.Fail,
  [PwcOrderStatus.Canceled]: BadgeType.Fail,
  [PwcOrderStatus.Declined]: BadgeType.Fail,
  [PwcOrderStatus.Failed]: BadgeType.Fail,
  [PwcOrderStatus.RefundInitiated]: BadgeType.Refund,
  [PwcOrderStatus.RefundSubmitted]: BadgeType.Refund,
  [PwcOrderStatus.RefundFailed]: BadgeType.Refund,
  [PwcOrderStatus.Refunded]: BadgeType.Refund,
  [PwcOrderStatus.PartialRefund]: BadgeType.Refund,
};

export const OrderStatusBadge = ({ status }: StatusBadgeProps) => {
  const { type, label } = badgePropsMap[status] || badgePropsMap[PwcOrderStatus.Initiated];
  const icon = badgeToIconMap[type];
  const badgeType = badgeTypeMap[type];

  const usedLabel = label || <IconDash />;

  return (
    <Badge type={badgeType}>
      <BadgeContent>
        {icon}
        {usedLabel}
      </BadgeContent>
    </Badge>
  );
};
